import React from 'react';

// --- IMPORTANTE: Use "export const" para corrigir o erro ---
export const Logo = ({ className, showText = true, theme = 'dark' }) => {
  // Ajuste de cores para o texto base (funciona em fundo claro ou escuro)
  const textColor = theme === 'dark' ? 'text-white' : 'text-slate-800';
  
  return (
    <div className={`flex items-center gap-3 select-none ${className}`}>
      {/* --- ÍCONE GEOMÉTRICO --- */}
      <div className="relative w-10 h-10 md:w-12 md:h-12 flex items-center justify-center filter drop-shadow-md">
        <svg
          viewBox="0 0 100 100"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="w-full h-full"
        >
          <defs>
            <linearGradient id="global_logo_gradient" x1="0" y1="50" x2="100" y2="50" gradientUnits="userSpaceOnUse">
              <stop offset="0%" stopColor="#00A3E0" />
              <stop offset="50%" stopColor="#2dd4bf" />
              <stop offset="100%" stopColor="#FDE047" />
            </linearGradient>
          </defs>

          <g 
            stroke="url(#global_logo_gradient)" 
            strokeWidth="10" 
            strokeLinecap="butt" 
            strokeLinejoin="miter"
          >
            <path d="M 20 85 V 50 L 50 20 L 80 50 V 85" fill="none" />
            <path d="M 35 85 V 55 L 50 40 L 65 55 V 85" fill="none" />
            <path d="M 50 85 V 60" strokeLinecap="round" /> 
          </g>
        </svg>
      </div>

      {/* --- TEXTO --- */}
      {showText && (
        <div className="flex flex-col justify-center leading-none">
          <div className="flex items-baseline gap-1">
            <span className={`text-xl md:text-2xl font-bold font-heading tracking-tight ${textColor}`}>
              Emprega
            </span>
            <span className="text-xl md:text-2xl font-extrabold font-heading tracking-tight text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-yellow-400">
              Mais
            </span>
          </div>
          
          <div className="flex items-center gap-2 mt-1">
            <div className="h-[2px] w-4 bg-gradient-to-r from-teal-500 to-transparent rounded-full opacity-50"></div>
            <span className={`text-[10px] md:text-xs font-bold uppercase tracking-[0.3em] ${textColor} opacity-80`}>
              Rondônia
            </span>
          </div>
        </div>
      )}
    </div>
  );
};